import SEO from "../components/SEO";

export default function Privacy() {
  return (
    <main data-testid="privacy-page">
      <SEO
        title="Privacy & Cookie Policy"
        description="Informativa privacy e cookie policy di GIANO Holding S.p.A. — trattamento dati ai sensi del Regolamento (UE) 2016/679 (GDPR)."
        path="/privacy"
      />
      <section className="py-20 md:py-24" style={{ background: "var(--bone)" }}>
        <div className="container-x" style={{ maxWidth: 820 }}>
          <div className="overline" style={{ color: "var(--terracotta)" }}>Documento legale</div>
          <h1 className="serif-display mt-4" style={{ fontSize: "clamp(36px, 5vw, 60px)" }}>Privacy & Cookie Policy</h1>
          <p className="mt-6 text-sm" style={{ opacity: 0.6 }}>Ultimo aggiornamento: {new Date().toLocaleDateString("it-IT", { day: "numeric", month: "long", year: "numeric" })}</p>

          <div className="mt-10 space-y-8" style={{ fontSize: 15, lineHeight: 1.75 }}>
            <Section title="1. Titolare del trattamento">
              <p><b>GIANO Holding S.p.A.</b>, Via Broletto 16, 20121 Milano · P.IVA 12345670158.<br/>Email: <a href="mailto:privacy@giano.com" style={{ color: "var(--terracotta)" }}>privacy@giano.com</a> · PEC: <a href="mailto:giano-holding@legalmail.it" style={{ color: "var(--terracotta)" }}>giano-holding@legalmail.it</a></p>
            </Section>
            <Section title="2. Dati raccolti">
              <p>Attraverso i moduli del sito raccogliamo: nome, email, telefono, ruolo, dati aziendali (denominazione, settore, ricavi, EBITDA, addetti, regione) ai fini della qualificazione della richiesta. Il conferimento è facoltativo; il mancato conferimento impedisce di ricevere risposta.</p>
            </Section>
            <Section title="3. Finalità e basi giuridiche">
              <ul style={{ marginLeft: 20 }}>
                <li>Riscontro alle richieste (art. 6.1.b GDPR — misure precontrattuali)</li>
                <li>Adempimenti fiscali e antiriciclaggio (art. 6.1.c GDPR — obbligo di legge)</li>
                <li>Analytics anonimi e alert Deal Radar (art. 6.1.a GDPR — consenso, revocabile in ogni momento)</li>
                <li>Comunicazione istituzionale su nuove aziende in portafoglio (art. 6.1.f GDPR — legittimo interesse, opt-out sempre disponibile)</li>
              </ul>
            </Section>
            <Section title="4. Cookie">
              <p>Il sito utilizza:</p>
              <ul style={{ marginLeft: 20 }}>
                <li><b>Cookie tecnici essenziali</b> (session, CSRF, preferenza lingua): non richiedono consenso.</li>
                <li><b>Cookie analitici anonimizzati</b>: attivi solo dopo consenso esplicito (bottone "Accetto tutti"). Nessuna profilazione di terze parti.</li>
              </ul>
              <p>Puoi revocare il consenso cancellando la voce <code>giano_cookie_consent_v1</code> dal localStorage o svuotando i dati del browser.</p>
            </Section>
            <Section title="5. Trasferimento dati e destinatari">
              <p>I dati sono trattati esclusivamente in UE. Fornitori tecnici (hosting, servizio email transazionale, MongoDB Atlas) operano come <em>responsabili del trattamento</em> ex art. 28 GDPR con contratti DPA in essere.</p>
            </Section>
            <Section title="6. Conservazione">
              <p>Dati di contatto: 24 mesi dall'ultima interazione. Valutazioni salvate: 5 anni. Log tecnici: 12 mesi. Alert Deal Radar: fino alla revoca dell'iscrizione.</p>
            </Section>
            <Section title="7. Diritti dell'interessato">
              <p>Puoi esercitare i diritti di accesso, rettifica, cancellazione, limitazione, portabilità e opposizione scrivendo a <a href="mailto:privacy@giano.com" style={{ color: "var(--terracotta)" }}>privacy@giano.com</a>. Diritto di reclamo al Garante Privacy — <a href="https://www.garanteprivacy.it" target="_blank" rel="noopener noreferrer" style={{ color: "var(--terracotta)" }}>garanteprivacy.it</a>.</p>
            </Section>
            <Section title="8. Modifiche">
              <p>Ogni modifica sostanziale sarà comunicata via banner sul sito e per email agli iscritti attivi. La versione corrente prevale su ogni precedente.</p>
            </Section>
          </div>
        </div>
      </section>
    </main>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="serif-display" style={{ fontSize: 24 }}>{title}</h2>
      <div className="mt-3" style={{ opacity: 0.85 }}>{children}</div>
    </div>
  );
}
